import React from 'react';
import "./App.css"

const Shadeinput = (props) => {
  return (
    <div className='shadeinput'>
        <div className='emojis'>🐼🐹🦁🌋🌈🐻</div>
        <input type="text" className="input" value={props.color} onChange={(e)=>props.onInputChange(e.target.value)}></input>
        <div className='emojis'>🌮🌱🌲🌷🌸🌼</div>
        </div>
  )
}

export default Shadeinput